import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSortDown = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M2.82006 16.1001L5.68006 18.9601V3.87012C5.68006 3.59012 5.90006 3.37012 6.18006 3.37012C6.46006 3.37012 6.68006 3.59012 6.68006 3.87012V18.9401L9.54006 16.0801C9.73006 15.8901 10.0301 15.8901 10.2201 16.0801C10.4101 16.2701 10.4101 16.5701 10.2201 16.7601L6.17006 20.8101L2.14006 16.7801C1.95006 16.5901 1.95006 16.2901 2.14006 16.1001C2.33006 15.9101 2.63006 15.9101 2.82006 16.1001Z' />
    <path d='M22.0201 7.35012C22.0201 7.63012 21.8001 7.85012 21.5201 7.85012H14.1501C13.8701 7.85012 13.6501 7.63012 13.6501 7.35012C13.6501 7.07012 13.8701 6.85012 14.1501 6.85012H21.5201C21.8001 6.85012 22.0201 7.07012 22.0201 7.35012Z' />
    <path d='M20.1601 12.0001C20.1601 12.2801 19.9401 12.5001 19.6601 12.5001H14.1501C13.8701 12.5001 13.6501 12.2801 13.6501 12.0001C13.6501 11.7201 13.8701 11.5001 14.1501 11.5001H19.6601C19.9401 11.5001 20.1601 11.7201 20.1601 12.0001Z' />
    <path d='M13.6501 16.6501C13.6501 16.9301 13.8701 17.1501 14.1501 17.1501H17.8001C18.0801 17.1501 18.3001 16.9301 18.3001 16.6501C18.3001 16.3701 18.0801 16.1501 17.8001 16.1501H14.1501C13.8701 16.1501 13.6501 16.3701 13.6501 16.6501Z' />
  </svg>
);
export default SvgSortDown;
